export default __webpack_public_path__ + "static/kv_pc_hevc-34727a29d66997ee5cb3e4645c8fc71d.mp4";